import { useNavigate } from "react-router-dom"
import { RateTableConfig } from "../../../../../../types"

type Props = {
  info: RateTableConfig
}

const NameCell = ({ info }: Props) => {
  const navigate = useNavigate()
  const { name, id } = info

  return (
    <td
      className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer"
      onClick={() => navigate(`/config-admin/rate-table/${id}`)}
    >
      <div className="flex items-center">
        <div className="font-bold mr-2">{name}</div>
      </div>
    </td>
  )
}

export default NameCell
